<template>
    <div @click="$emit('close')">
        <!-- <button @click="openBlockProds = !openBlockProds" class="button-default" style="margin:auto" v-text="getString('bloquear_desbloquear_produtos')"></button> -->
        <div class="select-modal-container"  @click.stop>
            <div class="title-box">
                <h2>{{ selectModalParams.title }}</h2>
            </div>
            <div class="search-box" v-if="selectModalParams.propertyToSearch && selectModalParams.propertyToSearch.length > 0">
                <label for="search">{{ getString('pesquisar') }}</label>
                <input type="text" autocomplete="off" id="search" name="search" v-model="search" @focus="show" data-layout="normal"/>
                <DefaultButton :text="getString('limpar')" @defaultBtnClick="search = ''" :outlined="true"></DefaultButton>
            </div>
            <ul>
                <li v-for="(item, key) in getList()" :key="key" @click="emitSelectOption(item)">
                    <div v-for="(property, key) in selectModalParams.propertyToShow" :key="key">
                        {{ item[property] }}
                    </div>
                </li>
            </ul>
            <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input"/>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
import VueTouchKeyboard from 'vue-touch-keyboard'
import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'

Vue.use(VueTouchKeyboard)
Vue.use(style)

export default {
    name: 'SelectModal',
    components: {
        DefaultButton,
        'vue-touch-keyboard': VueTouchKeyboard.component
    },
    data () {
        return {
            visible: false,
            listToShow: [],
            layout: 'normal',
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            input: null,
            openBlockProds: false,
            edit_icon: require('../../static/icons/close_white.svg'),
            somethingChange: false,
            search: ''
        }
    },
    props: ['selectModalParams'],
    methods: {
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                this.layout = e.target.dataset.layout
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getProdTradName: function (item) {
            const currentLanguage = LocaleController.getCurrentLanguage()
            const langknownProps = {
                'pt-br': item.subItemName || item.productName,
                'en': item.subItemNameEnglish || item.productNameEnglish,
                'es': item.subItemNameEspanish || item.productNameEspanish
            }
            return langknownProps[currentLanguage] || langknownProps['pt-br']
        },
        getList: function () {
            let data = this.selectModalParams.selectModalData
            let propertyToSearch = this.selectModalParams.propertyToSearch
            if (this.search && propertyToSearch) {
                const self = this
                let result = []
                data.forEach((item) => {
                    propertyToSearch.forEach((element) => {
                        let corresponds = false
                        corresponds = item[element].toLocaleLowerCase().includes(self.search.toLocaleLowerCase())
                        if (corresponds && !result.includes(item)) {
                            result.push(item)
                        }
                    })
                })
                return result
            }
            return data
        },
        emitSelectOption: function (item) {
            this.$emit(this.selectModalParams.selectAction, item)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import (reference) url("../assets/common.less");
.select-modal-container {
    font-size: 1.4rem;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: 35% 75px;
    background: @white;
    border-radius: 10px;
    z-index: 30;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    padding-bottom: 80px;
    height: 790px;
    .title-box {
        background-color: @primary-color;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px 10px 0px 0px;
        height: 120px;
        h2 {
            color: @white;
            margin: auto;
        }
    }
    .search-box {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 60px;
        background-color: @primary-light;
        button {
            height: 45px !important;
            min-width: 100px !important;
        }
        input {
            height: 40px;
            width: 375px;
            margin: 0 30px 0 30px;
            font-size: 120%;
            border: solid 1px @primary-dark;
        }
        label {
            color: white;
            font-size: 1.8rem;
        }
    }
    ul {
        list-style: none;
        height: 500px;
        overflow: auto;
        background: white;
        padding: 30px;
        border-radius: 5px;
        // width: 775px;
        width: inherit;
        &:before{
            content: attr(aria-label);
            font-size: 120%;
            font-weight: bold;
            margin: -15px 0 0 -15px;
            display: block;
            position: sticky;
            top: -30px;
            background: white;
            color: @primary-color;
        }
        li {
            padding-bottom: 5px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            border-bottom: solid 1px black;
            div {
                margin: 15px;
                font-size: 25px;
            }
        }
    }
    .prod-item-footer {
        position: relative;
        display: grid;
        grid-template-columns: auto;
        background: rgba(0, 0, 0, 0.1);
        height: 130px;
        border-radius: 0 0 10px 10px;
        button {
            position: relative;
            display: block;
            margin: auto;
        }
    }
    #keyboard {
        .keyboard;
    }
}
@media (min-width: 699px) and (max-width: 1025px) { //@tablet
    .select-modal-container {
        font-size: 15px;
        margin: auto 50px;
        // height: 500px;
        // width: 450px;
        .title-box {
            height: 50px;
            h2 {
                font-size: 25px;
            }
        }
        .search-box {
            height: 60px;
            input {
                font-size: 20px;
                height: 30px;
                padding: 0 10px;
                width: 200px;
                margin: 0 10px 0 10px;
            }
            label {
                font-size: 20px;
            }
        }
        ul {
            height: calc(100vw - 40px);
            li {
                div {
                    font-size: 25px !important;
                    margin: 10px !important;
                }
            }
        }
        .prod-item-footer {
            height: 60px;
        }
    }
}
@media (max-width: 698px) { // Gertec SK210
    .select-modal-container {
        font-size: 15px;
        margin: auto;
        height: 500px;
        width: 450px;
        .title-box {
            height: 50px;
            h2 {
                font-size: 25px;
            }
        }
        .search-box {
            height: 60px;
            input {
                font-size: 20px;
                height: 30px;
                padding: 0 10px;
                width: 200px;
                margin: 0 10px 0 10px;
            }
            label {
                font-size: 20px;
            }
        }
        ul {
            height: 350px;
            width: 390px;
            li {
                div {
                    font-size: 15px !important;
                    margin: 5px !important;
                }
            }
        }
        .prod-item-footer {
            height: 60px;
        }
    }
}

@media (orientation: landscape) { //@tablet
    .select-modal-container {
        font-size: 1.4rem;
        margin: 50px 100px;
        background: @white;
        border-radius: 10px;
        padding-bottom: 20px;
        height: auto;
        max-height: calc(100vh - 160px);
        .search-box {
            height: 60px;
            input {
                font-size: 20px;
                height: 30px;
                padding: 0 10px;
                width: 200px;
                margin: 0 10px 0 10px;
            }
            label {
                font-size: 20px;
            }
        }
        ul {
            height: auto;
            max-height: calc(100vh - 160px);
            li {
                div {
                    font-size: 25px !important;
                    margin: 10px !important;
                }
            }
        }
        .prod-item-footer {
            height: 60px;
        }
    }
    .select-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 29;
    background: rgba(0, 0, 0, 0.4); // opcional: escurece o fundo
    }
}

</style>



// WEBPACK FOOTER //
// src/components/SelectModal.vue